import { DEFAULT_TIMES_SETTINGS, type TimesSettings } from '@bonyaan/prayer-times';
import type { Locale } from '@/i18n/types';
import type { Accent, FunLevel, SchemeChoice, Skin } from '@/theme/types';

export interface Preferences {
  locale: Locale;
  scheme: SchemeChoice;
  accent: Accent;
  /** Set only when someone overrides what the age chose. */
  skinOverride: Skin | null;
  fun: FunLevel;
  /** Where and how prayer times are calculated. */
  times: TimesSettings;
}

export const DEFAULT_PREFERENCES: Preferences = {
  locale: 'en',
  // Auto out of the box: the app already knows where the sun is — it computes
  // the prayer times — so the first launch matches the sky rather than
  // guessing, and Day or Night stay one tap away in Settings.
  scheme: 'auto',
  accent: 'brass',
  skinOverride: null,
  fun: 'full',
  times: DEFAULT_TIMES_SETTINGS,
};

export interface PreferencesPort {
  get(): Promise<Preferences>;
  set(patch: Partial<Preferences>): Promise<Preferences>;
}
